import React from 'react';

const EyeIcon = () => (
  <svg width={20} height={20} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="eye-mask" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x={0} y={0} width={24} height={25}>
      <path d="M0 0.975512H24V24.9755H0V0.975512Z" fill="white" />
    </mask>
    <g mask="url(#eye-mask)">
      <path d="M0.515625 1.49114L23.4844 24.4599" stroke="currentColor" strokeWidth={1.6} strokeMiterlimit={10} />
      <path d="M12 17.1943C9.67364 17.1943 7.78125 15.3019 7.78125 12.9755C7.78125 10.6492 9.67364 8.75676 12 8.75676C14.3264 8.75676 16.2188 10.6492 16.2188 12.9755C16.2188 15.3019 14.3264 17.1943 12 17.1943Z" stroke="currentColor" strokeWidth={1.6} strokeMiterlimit={10} />
      <path d="M12 14.3818C11.2248 14.3818 10.5938 13.7507 10.5938 12.9755C10.5938 12.2003 11.2248 11.5693 12 11.5693C12.7752 11.5693 13.4062 12.2003 13.4062 12.9755C13.4062 13.7507 12.7752 14.3818 12 14.3818Z" stroke="currentColor" strokeWidth={1.6} strokeMiterlimit={10} />
      <path d="M23.1562 12.9755C23.1562 12.9755 18.2132 20.0067 12 20.0067C5.78681 20.0067 0.84375 12.9755 0.84375 12.9755C0.84375 12.9755 5.78681 5.94423 12 5.94423C18.2132 5.94423 23.1562 12.9755 23.1562 12.9755Z" stroke="currentColor" strokeWidth={1.6} strokeMiterlimit={10} />
    </g>
  </svg>
);

export default EyeIcon;
